import type { ResultOf } from '@graphql-typed-document-node/core';

import { ThirdPartyTypeEnum, graphql } from '@e-socna/data-layer';
import { EMPTY_ARRAY, EMPTY_STRING } from '@e-socna/empty';

import { generateId } from '../../../../utils/generate-id.util';

import { ThirdPartyFormTab } from '../../enums/tab.enum';

import { ThirdPartiesSelectionFormStep } from '../Selection';
import type {
  UniqueIdMaybeEmptyFieldValue,
  UniqueUsageMaybeEmptyFieldValue,
} from '../Selection/types/field-value.type';

import { useInitialGridState } from './hooks/useInitialGridState.hook';

const enrichValue = (id: UniqueIdMaybeEmptyFieldValue) =>
  !id
    ? null
    : {
        _id: generateId(),
        organizationId: id,
        functions: EMPTY_ARRAY,
      };

const getId = (membership: UniqueUsageMaybeEmptyFieldValue) =>
  !membership ? EMPTY_STRING : (membership as Membership).organizationId;

export const ThirdPartyForm_PersonMembershipsStep_Person_Fragment = graphql(`
  fragment ThirdPartyForm_PersonMembershipsStep_Person_Fragment on Person {
    activeMemberships {
      _id
      organizationId
      functions
      contextualRoleIds
      representativeTypeIds
    }
  }
`);

type Membership = ResultOf<
  typeof ThirdPartyForm_PersonMembershipsStep_Person_Fragment
>['activeMemberships'][number];

interface Props {
  readonly id: string;
  readonly isInternal: boolean;
  readonly setHasMemberships: (hasMemberships: boolean) => void;
}

export const ThirdPartyPersonMembershipsFormStep = ({
  isInternal,
  setHasMemberships,
}: Readonly<Props>) => {
  const { initialGridState } = useInitialGridState();

  return (
    <ThirdPartiesSelectionFormStep
      enrichValue={enrichValue}
      fieldName="activeMemberships"
      getId={getId}
      id={ThirdPartyFormTab.PersonMemberships}
      initialGridState={initialGridState}
      isInternal={isInternal}
      kind={ThirdPartyTypeEnum.Organization}
      setIsFieldUsed={setHasMemberships}
    />
  );
};
